import { render, staticRenderFns } from "./AgeBanner.vue?vue&type=template&id=615d2d9b&scoped=true"
import script from "./AgeBanner.vue?vue&type=script&lang=js"
export * from "./AgeBanner.vue?vue&type=script&lang=js"
import style0 from "./AgeBanner.vue?vue&type=style&index=0&id=615d2d9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615d2d9b",
  null
  
)

export default component.exports